import { render, staticRenderFns } from "./MessageLogin.vue?vue&type=template&id=713e7230&scoped=true"
import script from "./MessageLogin.vue?vue&type=script&lang=ts"
export * from "./MessageLogin.vue?vue&type=script&lang=ts"
import style0 from "./MessageLogin.vue?vue&type=style&index=0&id=713e7230&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713e7230",
  null
  
)

export default component.exports